import baseApplicationItem from './baseApplicationItem'
import moment from 'moment'
import {merge} from 'lodash'
import Vue from 'vue'

let defaultQueryStringGet = '?startDate=%startDate%&endDate=%endDate%'
const module = {
  endpoint: 'analytic/products',
  getNew: {
    deleted: false,
    name: null,
    description: null
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'name',
        title: 'nome',
        sortField: 'name'
      },
      {
        name: 'description',
        title: 'Descrizione',
        sortField: 'description'
      },
      {
        name: 'qty',
        title: 'Quantità',
        sortField: 'qty'
      },
      {
        name: 'brand',
        title: 'Brand',
        sortField: 'brand'
      },
      {
        name: 'category',
        title: 'Categoria',
        sortField: 'category'
      },
      {
        name: 'unitCost',
        title: 'Costo unitario',
        sortField: 'unitCost',
        callback: baseApplicationItem.currency
      },
      {
        name: 'totalCost',
        title: 'Costo Totale',
        sorField: 'totalCost',
        callback: baseApplicationItem.currency
      },
      {
        name: 'vat',
        title: 'Iva',
        sortField: 'vat',
        callback: baseApplicationItem.perc
      },
      {
        name: 'totalVatCost',
        title: 'Costo Totale Ivato',
        sortField: 'totalVatCost',
        callback: baseApplicationItem.currency
      },
      {
        name: 'totalAmount',
        title: 'Totale',
        sortField: 'totalAmount',
        callback: baseApplicationItem.currency
      },
      {
        name: 'profitPerc',
        title: 'Percentuale Profitto',
        sortField: 'profitPerc',
        callback: baseApplicationItem.perc
      },
      {
        name: 'profitValue',
        title: 'Valore Profitto',
        sortField: 'profitValue',
        callback: baseApplicationItem.currency
      }
    ],
    sortFunctions: {
    }
  },
  async getData (startDate = null, endDate = null) {
    try {
      let queryString = defaultQueryStringGet
      console.log(queryString)
      if (startDate != null) {
        const startTime = typeof startDate === 'string' ? startDate : moment(startDate.getTime()).format('YYYY-MM-DD')
        queryString = queryString.replace('%startDate%', `${startTime}`)
      }
      if (endDate != null) {
        const endTime = typeof endDate === 'string' ? endDate : moment(endDate.getTime()).format('YYYY-MM-DD')
        queryString = queryString.replace('%endDate%', `${endTime}`)
      }
      console.log(queryString)
      return (await Vue.http.get(`${this.endpoint}${queryString}`)).data
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/productAnalytics.js